import React from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";

const CompleteBookingModal = ({ completeBookingModal, handleClose, changeBookingData, completeAppointment }) => {
  return (
    <Modal size="lg" show={completeBookingModal} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title>Complete Clinical Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <div style={{ textAlign: "left", color: "green" }}>
              <p>This is a free form checklist for completing clinical service. Notes entered here are *internal*</p>
          </div>
        <Col>
          <Form.Group
            as={Row}
            controlId="formBookingId"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 15
            }}
          >
            <Form.Label id="cardFormLabel" column sm={8}>
              Enter clinical only time spent in minutes <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                type="number"
                placeholder="0"
                aria-label="minutes spent"
                aria-describedby="basic-addon1"
                onChange={e => changeBookingData("clinicalServiceMins", e.target.value)}
              />
            </Col>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group
            as={Row}
            controlId="formBookingId"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 15
            }}
          >
            <Form.Label id="cardFormLabel" column sm={8}>
              Confirm patient summary sent <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Col sm={4} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Form.Check
                reverse
                type="switch"
                id="custom-switch"
                aria-label="minutes spent"
                aria-describedby="basic-addon1"
                onChange={e => changeBookingData("ackPatientSummarySent", e.target.value === "on" ? true : false)}
              />
            </Col>
          </Form.Group>
        </Col>

          <Col style={{ flex: 1.6 }}>
              <Form.Label id="cardFormLabel" column sm={8}>
                  Enter clinical service closing notes:<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                  placeholder="Briefly describe the encounter, clinical service provided, questions, follow up, etc."
                  style={{ border: "1px solid lightgray", background: "rgba(0,0,0,0.05)" }}
                  as="textarea"
                  rows={10}
                  onChange={e => changeBookingData("clinicalServiceNotes", e.target.value)}
              />
          </Col>

          {/*<Col>*/}
          {/*    <Form.Group*/}
          {/*        as={Row}*/}
          {/*        controlId="formBookingId"*/}
          {/*        style={{*/}
          {/*            display: "flex",*/}
          {/*            justifyContent: "space-between",*/}
          {/*            marginBottom: 15*/}
          {/*        }}*/}
          {/*    >*/}
          {/*        <Form.Label id="cardFormLabel" column sm={8}>*/}
          {/*            Close clinical service <span style={{ color: "red" }}>*</span>*/}
          {/*        </Form.Label>*/}
          {/*        <Col sm={4}>*/}
          {/*            <Form.Control*/}
          {/*                type="textarea"*/}
          {/*                as="textarea"*/}
          {/*                row={8}*/}
          {/*                placeholder="Briefly describe the encounter, clinical service provided, questions, follow up, etc."*/}
          {/*                aria-label="closing notes"*/}
          {/*                aria-describedby="basic-addon1"*/}
          {/*                onChange={e => changeBookingData("clinicalServiceNotes", e.target.value)}*/}
          {/*            />*/}
          {/*        </Col>*/}
          {/*    </Form.Group>*/}
          {/*</Col>*/}

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={completeAppointment}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompleteBookingModal;
